export enum HEALTH_DATA_STEPS {
  DISABLED = 'disabled',
  ENABLED = 'enabled',
}
